import React from 'react';
import './Challenges.css';
import useScrollReveal from '../hooks/useScrollReveal';

function Challenges() {
  const ref = useScrollReveal();
  return (
    <section id="challenges" className="challenges">
      <div className="section-container">
        <div ref={ref} className="reveal">
          <h2 className="section-title">Ihre großen Herausforderungen</h2>

          <div className="challenges-content">
            <p className="challenges-text">
              Der Fachkräftemangel ist mehr als eine Lücke im Personalplan – er gefährdet Ihre Wettbewerbsfähigkeit und Ihr Wachstum, besonders als kleines und mittelständisches Unternehmen. Gleichzeitig gefährdet der Wissensverlust durch eine möglicherweise anstehende Generationenübergabe die operative Kontinuität und macht Ihr Unternehmen verletzlich.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Challenges;
